import { render, staticRenderFns } from "./GoxipCirclePointStatus.vue?vue&type=template&id=23ed8a21&scoped=true&"
import script from "./GoxipCirclePointStatus.vue?vue&type=script&lang=js&"
export * from "./GoxipCirclePointStatus.vue?vue&type=script&lang=js&"
import style0 from "./GoxipCirclePointStatus.vue?vue&type=style&index=0&id=23ed8a21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed8a21",
  null
  
)

export default component.exports